module.exports = __webpack_public_path__ + "media/images/summit-1-3a7a5b3a05bbdf8448a23a227e5b07fd.jpg";